




















































































































































































import { mailMergeService } from '@/services'
import { MailMergeTemplate } from '@/types/MailMergeTypes'
import dayjs from 'dayjs'
import { saveAs } from 'file-saver'
import Vue from 'vue'

export default Vue.extend({
    name: 'MailMergeTemplatePicker',

    filters: {
        formatDate(value: string | undefined): string {
            if (!value) return ''
            return dayjs(value).format('MMM D, YYYY')
        },
    },

    props: {
        /** v-model: controls dialog visibility */
        value: {
            type: Boolean,
            default: false,
        },
        /** Page name used to scope templates */
        pageName: {
            type: String,
            required: true,
        },
        /** The data-table row record used as merge replacements */
        record: {
            type: Object as () => Record<string, string>,
            default: () => ({}),
        },
    },

    data() {
        return {
            templates: [] as MailMergeTemplate[],
            totalCount: 0,
            loading: false,
            fetchError: null as string | null,
            search: '',
            debounceTimer: null as ReturnType<typeof setTimeout> | null,
            page: 1,
            pageSize: 8,
            replacingId: null as string | null,
            replaceError: null as string | null,
        }
    },

    computed: {
        totalPages(): number {
            return Math.ceil(this.totalCount / this.pageSize)
        },
    },

    watch: {
        value(open: boolean) {
            if (open) {
                this.resetState()
                this.fetchTemplates()
            }
        },
    },

    methods: {
        resetState() {
            this.search = ''
            this.page = 1
            this.templates = []
            this.totalCount = 0
            this.fetchError = null
            this.replaceError = null
            this.replacingId = null
        },

        async fetchTemplates() {
            this.loading = true
            this.fetchError = null
            try {
                const result = await mailMergeService.getTemplates(
                    this.page,
                    this.pageSize,
                    this.pageName,
                    this.search || undefined,
                )
                this.templates = result.records
                this.totalCount = result.totalRecords
            } catch {
                this.fetchError = 'Failed to load templates. Please try again.'
            } finally {
                this.loading = false
            }
        },

        onSearchInput() {
            if (this.debounceTimer) clearTimeout(this.debounceTimer)
            this.debounceTimer = setTimeout(() => {
                this.page = 1
                this.fetchTemplates()
            }, 350)
        },

        onSearchClear() {
            this.search = ''
            this.page = 1
            this.fetchTemplates()
        },

        async onSelect(template: MailMergeTemplate) {
            if (this.replacingId) return
            this.replacingId = template.id ?? null
            this.replaceError = null
            try {
                const result = await mailMergeService.templateReplace(
                    this.record,
                    template.id ?? '',
                )
                const fileName = template.fileName || `${template.name}.docx`
                saveAs(result.data, fileName)
                this.$emit('replaced', template)
                this.$emit('input', false)
            } catch {
                this.replaceError = `Failed to apply "${template.name}". Please try again.`
            } finally {
                this.replacingId = null
            }
        },
    },
})
